import { useState, useMemo, useCallback } from 'react';
import {
  JaneDetailViewComponentMap,
  JaneDetailsViewActiveTabType,
} from 'modals/JaneDetailsModal/views/JaneDetailsView/JaneDetailsView.types';
import {
  NavigationButton,
  NavigationButtonsWrapper,
  JaneDetailsNavigationWrapper,
} from 'modals/JaneDetailsModal/views/JaneDetailsView/JaneDetailsView.styled';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import isUserAgencySelector from 'store/selectors/userSelectors/isUserAgencySelector';

const B2B_TABS: [string, JaneDetailsViewActiveTabType][] = [
  ['General', 'GeneralTab'],
  ['Reviews', 'ReviewsTab'],
  ['Activity', 'ActivityTab'],
];

const AGENCY_TABS: [string, JaneDetailsViewActiveTabType][] = [
  ['General', 'GeneralTab'],
  ['Reviews', 'ReviewsTab'],
];

export const JaneDetailsView = () => {
  const { t } = useTranslation();
  const isUserAgency = useSelector(isUserAgencySelector);
  const [activeTab, setActiveTab] = useState<JaneDetailsViewActiveTabType>('GeneralTab');

  const tabs = useMemo(() => (isUserAgency ? AGENCY_TABS : B2B_TABS), [isUserAgency]);
  const ActiveTabComponent = useMemo(() => JaneDetailViewComponentMap[activeTab], [activeTab]);

  const handleTabClick = useCallback(
    (tab: JaneDetailsViewActiveTabType) => {
      if (activeTab !== tab) {
        setActiveTab(tab);
      }
    },
    [activeTab],
  );

  return (
    <div>
      <JaneDetailsNavigationWrapper>
        <NavigationButtonsWrapper>
          {tabs.map(([label, _enum]) => (
            <NavigationButton
              key={label}
              onClick={() => handleTabClick(_enum)}
              isActive={activeTab === _enum}
            >
              {t(`team_member:${label}`)}
            </NavigationButton>
          ))}
        </NavigationButtonsWrapper>
      </JaneDetailsNavigationWrapper>
      <ActiveTabComponent />
    </div>
  );
};
